import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DataSourceRequestState, toDataSourceRequestString } from '@progress/kendo-data-query';

@Injectable({
  providedIn: 'root'
})
export class ClientDirectoryService {

  constructor(private readonly _http: HttpClient) { }

  getClientDirectory(state: DataSourceRequestState, SearchText: any) {
    let queryStr = `${toDataSourceRequestString(state)}`;
    return this._http.get<any>(`${environment.apiUrl}/Company/GetDoctorDirectory?${queryStr}&SearchText=${SearchText}`);
  }

  updateClientDirectory(data: any) {
    return this._http.post(`${environment.apiUrl}/Company/UpdateDoctorDirectory`, data);
  }
  CreateClientDirectory(data: any) {
    return this._http.post(`${environment.apiUrl}/Company/AddDoctorDirectory`, data);
  }

  getServicesAllData() {
    return this._http.get(`${environment.apiUrl}/CompanyServices/GetServices`);
  }

  CreateService(data: any) {
    return this._http.post(`${environment.apiUrl}/CompanyServices/Create`, data);
  }

  UpdateDirectoryStatus(id: any, status: boolean) {
    return this._http.put(`${environment.apiUrl}/Company/UpdateDirectoryStatus?id=${id}&status=${status}`, null);
  }

  getSpecializationAllData() {
    return this._http.get(`${environment.apiUrl}/CompanySpecialization/GetSpecializations`);
  }

  getSpecializationCategories() {
    return this._http.get(`${environment.apiUrl}/CompanySpecialization/GetSpecializationCategories`);
  }

  getSpecializationsByCategory(categoryId: number) {
    return this._http.get(`${environment.apiUrl}/CompanySpecialization/GetSpecializationsByCategory?categoryId=${categoryId}`);
  }

  CreateSpecialization(data: any) {
    return this._http.post(`${environment.apiUrl}/CompanySpecialization/Create`, data);
  }

  getLanguagesAllData() {
    return this._http.get(`${environment.apiUrl}/Language/GetLanguages`);
  }

  CreateLanguage(data: any) {
    return this._http.post(`${environment.apiUrl}/Language/Create`, data);
  }

  matchEmailName(Email: any) {
    let model = { Email: Email }
    return this._http.post(
      `${environment.apiUrl}/Common/CheckEmailExists`,
      model
    );
  }

  matchEmailNameById(Email: any, companyId: any) {
    return this._http.post(
      `${environment.apiUrl}/Company/CheckEmailExistsWithId?Email=${Email}&companyId=${companyId}`,
      ""
    );
  }

  convertDirectorytoDomain(data: any) {
    return this._http.post(`${environment.apiUrl}/Company/CreateDomainOfDoctorDirectory`, data);
  }

  matchClinicName(CompanyName: any, companyId: any) {
    return this._http.post(
      `${environment.apiUrl}/Company/CheckClinicNameExistsWithId?ClinicName=${CompanyName}&companyId=${companyId}`,
      ""
    );
  }

  matchDomain(CompanyCode: any) {
    return this._http.post(
      `${environment.apiUrl}/Common/CheckCompanyCodeExists?CompanyCode=${CompanyCode}`,
      ""
    );
  }

  getCountry() {
    return this._http.get<any>(
      `${environment.apiUrl}/Common/GetCountry`
    );
  }

}
